<template>
<div class="catch-link">
 
    <a @click="openAHref" :href="href" :target="target"><slot></slot></a>
</div>

</template>

<script>
/*
- catching a link for opening
- open for browser in target _blank
- or open with in app browser in case we are on mobile
*/

export default {
  name: 'catch-link',
  props:{
    href:{default:undefined},
    target:{default:"_blank"},
  },
  data:function(){
    return {
    }
  },
  computed:{
  },
  components:{
    
  },
  methods:{
    openAHref(e){

    if(e.currentTarget.tagName!="A"){
      return;
    }
    
    // check if protocol is defined on tag
    var href=e.currentTarget.getAttribute("href");
    if (href.indexOf("http://") == -1 && href.indexOf("https://") == -1) {
        // let browser decide by prefixing with "//"
        href="http://"+href;
        e.currentTarget.setAttribute("href",href);
        e.currentTarget.target="_blank"
    }
    
    e.currentTarget.href=href;
    
    
    
       
    },
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

